import { find, head } from "lodash";
import { useCurrentProject } from "@radarly/core/project/use-cases";
import { useCanAccessWorkspace } from "@radarly/core/security/use-cases";

export function useCurrentWorkspaceBootstrap(id: number) {
  const project = useCurrentProject();
  const workspaces = project?.dashboards;
  const workspace = find(workspaces, { id }) ?? head(workspaces);
  const canAccessWorkspace = useCanAccessWorkspace(project, id);
  return {
    workspace,
    loading: false,
    error: !canAccessWorkspace,
  };
}
